import { FC, ReactNode } from "react";
import { Box, makeStyles, Typography } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  warningMessage: {
    border: "1px solid #f2c94c",
    backgroundColor: "#fcf2d4",
    padding: theme.spacing(1.25),
    "& > div": {
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: 14,
    },
    "& > span": {
      fontSize: 12,
    },
  },
}));

interface WarningMessageProps {
  title: string;
  description: string | ReactNode;
}

const WarningMessage: FC<WarningMessageProps> = ({ title, description }) => {
  const classes = useStyles();
  return (
    <Box className={classes.warningMessage}>
      <Typography component="div">{title}</Typography>
      <Typography component="span">{description}</Typography>
    </Box>
  );
};

export default WarningMessage;
